export class MedicalConditionsVaccinesModel {
    public id: string;
    public medicalCondition: string;
    public vaccine: any;
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/master-data/medical-conditions-vaccines.model.ts